export default __webpack_public_path__ + "static/media/ic-faq.db6f2015.svg";